module.exports = __webpack_public_path__ + "static/8-cta-3df8faa6026aefb58670abc3c46ce4d4.png";